import { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";

import {
    getAllPendingProperties,
    updatePropertiesStatus,
} from "../../../services/propertyService";

const LIMIT = 12;

export const usePendingProperties = () => {
    const [properties, setProperties] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const [filters, setFilters] = useState({
        title: "",
        projectName: "",
        propertyType: "",
    });

    const [updatingStatus, setUpdatingStatus] = useState({});

    const fetchProperties = useCallback(async () => {
        setLoading(true);
        setError(null);

        try {
            const cleanFilters = Object.fromEntries(
                Object.entries(filters).filter(
                    ([_, value]) =>
                        value !== "" &&
                        value !== null &&
                        value !== undefined
                )
            );

            const data = await getAllPendingProperties(
                cleanFilters,
                page,
                LIMIT
            );

            setProperties(data.properties || []);
            setTotalPages(data.totalPages || 1);
        } catch (error) {
            const message = error.message || "Lỗi tải dữ liệu";
            setError(message);
            toast.error(message);
        } finally {
            setLoading(false);
        }
    }, [filters, page]);

    useEffect(() => {
        fetchProperties();
    }, [fetchProperties]);

    const updateStatus = async (propertyId, status) => {
        setUpdatingStatus((prev) => ({
            ...prev,
            [propertyId]: true,
        }));

        try {
            await updatePropertiesStatus(propertyId, status);

            setProperties((prev) =>
                prev.filter((item) => item.id !== propertyId)
            );

            toast.success(
                status === "approved"
                    ? "Đã phê duyệt bất động sản"
                    : "Đã từ chối bất động sản"
            );

            return true;
        } catch (error) {
            toast.error(error.message);
            return false;
        } finally {
            setUpdatingStatus((prev) => ({
                ...prev,
                [propertyId]: false,
            }));
        }
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;

        setFilters((prev) => ({
            ...prev,
            [name]: value,
        }));

        setPage(1);
    };

    return {
        properties,
        loading,
        error,
        page,
        totalPages,
        filters,
        updatingStatus,

        setPage,
        handleFilterChange,

        approveProperty: (id) =>
            updateStatus(id, "approved"),

        rejectProperty: (id) =>
            updateStatus(id, "rejected"),
    };
};